import {GET_FORM_ORDER_RETURN_NOSEAL} from 'shared/constants/ActionTypes';

const initialState = {
  form: {
    noSeals: [
      {
        sealNo: '',
        isRepair: false,
      },
    ],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_ORDER_RETURN_NOSEAL:
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
